import * as Yup from 'yup'

export const validationSchemasVisaProvision = (fechaAP, fechaS) => {
    let validation = {};

    validation.codMonedaIngreso = Yup.string().required('Este campo es obligatorio.')
    validation.idInstanciaProvision = Yup.string().required('Este campo es obligatorio.')
    validation.situacionProvision = Yup.string().required('Este campo es obligatorio.')
    validation.comentario = Yup.string().required('Este campo es obligatorio.')
    validation.responsabilidadAsegurado = Yup.string().required('Este campo es obligatorio.')
    validation.amparoAfectado = Yup.string().required('Este campo es obligatorio.')

    if (fechaAP && fechaS) {
        validation.fechaActualizacion = Yup.date().test(
            "fechaActualizacion",
            'Fecha inválida.',
            (value) => {
                let fechaResultAP = true;
                let fechaResultS = true;

                if (value === "" || value === undefined) return true;
                if (fechaAP && fechaAP !== "0000-00-00") fechaResultAP = value >= new Date(fechaAP);
                if (fechaS && fechaS !== "0000-00-00") fechaResultS = value >= new Date(fechaS)

                return fechaResultAP && fechaResultS;
            }
        );
    }

    validation.file = Yup
        .mixed()
        .test('fileSize', 'Tamaño máximo del archivo 10MB.',
            (value) => {
                if (!value) return true;
                return value.size <= (10 * 1000000);
            })

    return Yup.object().shape(validation);
}